import React, { Component } from 'react'
import Sidebar from './components/layout/Sidebar.jsx'

const withLayout = (Comp, conditionalSidebar, collapsedSidebar) => {
  class WithLayout extends Component {
    render () {
      return (
        <div className='app__main'>
          {conditionalSidebar && collapsedSidebar ? <Sidebar collapsed /> : conditionalSidebar && <Sidebar />}
          <Comp {...this.props} />
        </div>
      )
    }
  }
  return WithLayout
}

export default withLayout
